import { render, staticRenderFns } from "./BirthdaySelect.vue?vue&type=template&id=3ef8803e&scoped=true&"
import script from "./BirthdaySelect.vue?vue&type=script&lang=js&"
export * from "./BirthdaySelect.vue?vue&type=script&lang=js&"
import style0 from "./BirthdaySelect.vue?vue&type=style&index=0&id=3ef8803e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ef8803e",
  null
  
)

export default component.exports